<template>
  <div class="membership">
    <HeaderParticipant
        :participants="participants"
        :participant="participant"
        @selectParticipants="selectParticipants"
        @changeSelect="changeSelect"
    />
    <v-row :class="{ 'mt-4': !age18 }">
      <v-col cols="12" md="12" sm="12">
        <!-- AMA D14 Dialog -->
        <MembershipDialog 
          :value="dialogAmaD14" 
          dialog-type="d14"
          :form="formAMA" 
          :rules="rules" 
          :buttonColor="buttonColor"
          :buttonDangerColor="buttonDangerColor"
          :numberAvailable="numberAvailable" 
          :errorAmaMsg="errorAmaMsg" 
          :btnUpdateProfile="btnUpdateProfile" 
          :showAmaInfo="showAmaInfo"
          :internalShowAmaInfo="internalShowAmaInfo"
          :isAccountManager="isAccountManager"
          :membershipItems="membershipResponseItems"
          :loading="loading"
          @validate="validateAma"
          @update-profile="updateProfile"
          @go-to-profile="goToProfileAMA"
          @input="dialogAmaD14 = $event"
          @cancel="cancelDialog"
          @save-d14="handleSaveD14"
          @update:memberId="formAMA.memberId = $event"
        />
        <!-- AMA Dialog -->
        <MembershipDialog 
          :value="dialogAma" 
          dialog-type="ama"
          :form="formAMA" 
          :rules="rules" 
          :buttonColor="buttonColor"
          :buttonDangerColor="buttonDangerColor"
          :numberAvailable="numberAvailable" 
          :errorAmaMsg="errorAmaMsg" 
          :btnUpdateProfile="btnUpdateProfile" 
          :showAmaInfo="showAmaInfo"
          :internalShowAmaInfo="internalShowAmaInfo"
          :isAccountManager="isAccountManager"
          :membershipItems="membershipResponseItems"
          :loading="loading"
          @go-to-profile="goToProfileAMA"
          @update-profile="updateProfile"
          @input="dialogAma = $event"
          @cancel="cancelDialog"
          @validate="validateAma"
          @add="addAma"          
          @update:memberId="formAMA.memberId = $event"
        />
        <v-dialog v-model="dialogDelete" max-width="600px">
          <v-card>
            <v-card-title class="headline">{{ $t('membership.delete') }}</v-card-title>
            <v-card-text>
              <p class="mt16">{{ $t('membership.sure_delete') }}</p>
            </v-card-text>
            <v-card-actions class="d-flex justify-start px-4 pb-4">
              <v-spacer></v-spacer>
              <v-btn
                class="btn mr-2"
                :color="`${buttonColor}`"
                @click="closeDelete"
              >{{ $t('membership.cancel') }}</v-btn>
              <v-btn
                :color="`${buttonColor}`"
                class="btn"
                @click="deleteItemConfirm"
              >{{ $t('membership.delete') }}</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="viewRow" max-width="504px">
          <v-card class="mx-auto">
            <v-card-text class="bcard">
              <div id="printMe" style="display:none;">
                <div class="card" >
                  <div class="card-body" style="padding-left:10px; padding-right:10px;">
                    <v-row >
                      <v-col md="12" class="text-left">
                        <v-row style="position:relative">
                          <img src="@/assets/images/BackGroundImage.png" style="width:480px;display:inline;">
                          <v-col style="float:left;text-align:left;position:absolute;top:68px;left:20px;">
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.organization") }}</span>: {{membershipDataCard.organizationName}}</p>
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.membershipPeriod") }}</span>: {{membershipDataCard.membershipPeriod}} </p>
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.membershipNumber") }}</span>: {{membershipDataCard.membershipNumber}} </p>
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.name") }}</span>: {{membershipDataCard.name}} </p>
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.class") }}</span>: {{membershipDataCard.className}} </p>
                            <p style="line-height:0.8;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("membership.number") }}</span>: {{membershipDataCard.raceNumber}} </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
              <v-row style="padding-top: 20px;">
                <v-col md="12" class="text-left" id="printMe1">
                  <v-row class="bg_row">
                    <v-col cols="12">
                      <v-row>
                        <v-col md="5" class="pb-0">
                          <p>{{ $t("membership.organization") }}: </p>
                        </v-col>
                        <v-col md="y" class="pb-0">
                          <p>{{membershipDataCard.organizationName}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.membershipPeriod") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.membershipPeriod}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.membershipNumber") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.membershipNumber}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.name") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.name}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.class") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.className}}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="5" class="py-0">
                          <p>{{ $t("membership.number") }}: </p>
                        </v-col>
                        <v-col md="y" class="py-0">
                          <p>{{membershipDataCard.raceNumber}}</p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" class="text-right">
                  <v-btn @click="printCard" class="mr-2">{{ $t("yourRegistration.print") }}</v-btn>
                  <v-btn @click="closeDeleteView">{{ $t("viewRegistration.close") }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <MembershipTable 
          :participantList="participantList" 
          :organizationsAvailableForAma="organizationsAvailableForAma"
          :signWaiverAvailability="organizationWaiverSignAvailability"
          :organizationHasWaiverDocuments="organizationHasWaiverDocuments"
          @openDialog="openDialog"
          @viewHistory="viewHistory"
          @deleteItem="deleteItem"
          @renew="renew"
          @signWaiverNow="signWaiverNow"
        />
                </v-col>
              </v-row>
    <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
  </div>
</template>

<script>
import MembershipService from '../services/MembershipService';
import AuthService from '../services/AuthService';
import OrganizationService from '../services/OrganizationService';
import AMAService from '../services/AMAService';
import moment from "moment";
import Snack from "../components/notifications/Snack";
import { VCard, VCol, VRow, VBtn, VCardText, VDialog,
         VCardTitle, VCardActions, VSpacer } from 'vuetify/lib';
import ProfileService from "@/services/ProfileService";
import WaiverService from "@/services/WaiverService";
import { formatDateForHumans } from "@/helpers/date-helper";
import { mapState } from "vuex";
import HeaderParticipant from "@/components/HeaderParticipant";
import MembershipTable from "@/components/yourMembership/MembershipTable";
import MembershipDialog from "@/components/yourMembership/MembershipDialog";
export default {
  name: "Membership",
  components:{
    Snack,
    VCard, VCol, VRow, VBtn, VCardText, VDialog, VCardTitle, VCardActions, VSpacer,
    HeaderParticipant, MembershipTable, MembershipDialog
  },
  data() {
    const membershipForm = Object.freeze({
      id: 0,
      organizerId: 0,
      className: "",
      number: 0,
      memberId: null,
      membershipTblId: "",
      expDate: "",
      lifemembercheckbox: false,
      allowEmails: false,
      userId: 0,
      timeout: null,
      url: '',
      preRegFrom: '',
      user: null
    });
    return {
      buttonColor: "primary",
      buttonDangerColor: "error",
      expDateMenu: "",
      snackbar: false,
      msg_snackbar: "",
      color_snackbar: "",
      dialog: false,
      editedIndex: -1,
      dialogDelete: false,
      membershipForm,
      internalShowAmaInfo: false,
      form: Object.assign({}, membershipForm),
      formAMA: Object.assign({}, membershipForm),
      formD14AMA: Object.assign({}, membershipForm),
      d14Data:{
        url: '',
        organizationId: 0,
        organizerId: 0,
        organizationName: '',
        allowPublicView: 0,
        allowSignup: 0,
        selfRegistration: false
      },
      isFoundError: false,
      membershipItems: [],
      defaultItem: {
        organizerId: 0,
        className: "",
        number: 0,
        memberId: null,
        membershipTblId: "",
        expDate: "",
        lifemembercheckbox: false,
        allowEmails: false
      },
      endDateMenu: false,
      clubItems: [],
      userId: '',
      selfRegLink: '',
      selfRegMessage: '',
      selectDisabled: false,
      cardBGColor: "#f1f1f1",
      participantList: [],
      viewRow: false,
      membershipDataCard: false,
      bandLoadingPartSelected: false,
      numberAvailable: false,
      dialogAma: false,
      errorAmaMsg: "",
      requireUpdateProfile: false,
      btnUpdateProfile: "",
      showAmaInfo: false,
      errorsAma: [],
      participantSelected: null,
      isAccountManager: true,
      organizationsAvailableForAma: [],
      dialogAmaD14: false,
      membershipResponseItems: [],
      loading: false,
      organizationWaiverSignAvailability: {},
      organizationHasWaiverDocuments: {},
      pendingWaiverStatusRefresh: false,
      checkingWaiverStatusRefresh: false,
      waiverStatusRefreshIntervalId: null
    };
  },
  created: function() {
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.buttonDangerColor = this.$store.getters.env.get('VUE_APP_BUTTON_DANGER_COLOR');
    this.cardBGColor = this.$store.getters.env.get('VUE_APP_BACKGROUND_CARD_PART');
    this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');
    this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');
    this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');
    this.getParticipants();
  },
  mounted() {
    this.$emit("titlePage", "membership.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
    this.getOrganizationsAvailableForAma();
    window.addEventListener("focus", this.handleWindowFocusAfterWaiverSign);
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.handleWindowFocusAfterWaiverSign);
    this.clearWaiverStatusRefreshInterval();
  },
  computed: {
    membershipHeaders() {
      return [
        {
            text: this.$t("yourRegistration.view"),
            value: "view",
            sortable: false
        },
        {
          text: this.$t("membership.organization_name"),
          align: "",
          sortable: false,
          value: "organizationName"
        },
        { text: this.$t("membership.class"), value: "className" },
        { text: this.$t("membership.race_num"), value: "raceNumber" },
        { text: this.$t("membership.membership_number"), value: "membershipNumber" },
        {
          text: this.$t("membership.membership_expiration"),
          value: "validTo"
        },
        {
          text: this.$t("membership.membership_type"),
          value: "membershipTypeName",
          sortable: false
        },
        {
          text: this.$t("membership.actions"),
          value: "actions",
          sortable: false
        }
      ];
    },
    ...mapState({
      userName(state) {
          return state.session.username;
      },
      age18: (state) => state.session.age18,
      userStore: (state) => state.session.user,
      participants: (state) => state.session.participants,
      participant: (state) => state.session.participantsSelected,
      hideMembershipRegistration: state => state.env.get('VUE_APP_HIDE_MEMBERSHIP_REG'),
    }),
    membershipNumber() {
      return this.form.memberId;
    },
    showAmaD14(){
      return this.d14Data && this.d14Data.selfRegistration;
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    userStore(val) {
      if(val) {
        this.getParticipants();
      }
    },
    participant() {
      if(!this.bandLoadingPartSelected) {
        this.bandLoadingPartSelected = true;
        this.selectParticipants();
      }
    }
  },
  methods: {
    getBackendMessageKey(message) {
      if (typeof message === 'string' && message.length > 0) {
        return message;
      }
      if (Array.isArray(message) && message.length > 0 && typeof message[0] === 'string') {
        return message[0];
      }
      return null;
    },
    resolveBackendMessage(message) {
      const key = this.getBackendMessageKey(message);
      if (!key) {
        return this.$t("common.error_general");
      }

      const namespaces = ["eventWaiver", "registerEvent", "common"];
      const namespace = namespaces.find((ns) => this.$te(`${ns}.${key}`));
      return namespace ? this.$t(`${namespace}.${key}`) : this.$t("common.error_general");
    },
    async getOrganizationsAvailableForAma(){
      const response = await OrganizationService.getOrganizationsAvailableForAma();
      let responseData = response.data.message;
      this.organizationsAvailableForAma = responseData;
    },
    goToProfileAMA(){
      this.initializeFields();
      window.open("https://ama.users.membersuite.com/auth/portal-login", '_blank');
    },
    initializeFields(){
      this.dialogAmaD14 = false; 
      this.dialogAma = false;
      this.numberAvailable = false;
      this.errorAmaMsg = "";
      this.requireUpdateProfile = false;
      this.showAmaInfo = false;
      this.btnUpdateProfile = null;
      this.formAMA.birthDate = null;
      this.formAMA.firstName = null;
      this.formAMA.lastName = null;
      this.formAMA.memberId = null;
    },
    async updateProfile(){
      this.loading = true;
      let updateArray = {
        "userId": this.formAMA.userId,
        "authUserId": this.userStore.id        
      };

      if(this.formAMA.birthDate){
        updateArray.birthDate = this.formAMA.birthDate;
      }
      if(this.formAMA.firstName){
        updateArray.firstName = this.formAMA.firstName;
      }
      if(this.formAMA.lastName){
        updateArray.lastName = this.formAMA.lastName;
      }
      
      let response = await ProfileService.updateProfile(updateArray);

      if(response && response.data.success){       
        let updatedParticipant = this.participantList.find(p => p.userId === this.formAMA.userId);
        const userResponse = response.data.message;

        const newUserData = {
            birthDate: userResponse.birthday,
            firstName: userResponse.firstName,
            lastName: userResponse.lastName,
            names: userResponse.firstName + " " + userResponse.lastName,
        };

          this.formAMA.user = {
            ...this.formAMA.user,
            ...newUserData 
          };

        if (updatedParticipant) {
          Object.assign(updatedParticipant, newUserData);
          updatedParticipant.names = newUserData.names; 
          this.participantSelected = updatedParticipant;
            this.updateParticipantInStore(updatedParticipant);
        }
        this.numberAvailable = false;
        this.showSnackBar(this.$t("profile.msg_profile_sucess"), "success");
        this.errorAmaMsg = "";
        await this.validateAma();
        this.$store.dispatch('setUserAction');
        this.showAmaInfo = false;
      }else{
        this.isAccountManager = false;
      }
      this.loading = false;
    },
    cancelDialog(){
      this.dialogAma = false;
      this.dialogAmaD14 = false;
      this.initializeFields();
      this.participantSelected = null;
    },
    async validateAma() {
      this.loading = true;
      this.numberAvailable = false;
      this.errorAmaMsg = "";
      this.requireUpdateProfile = false;
      this.btnUpdateProfile = null;
      let data = null;
      let response = null;
      let organizationName = "";

      const { memberId, user, item } = this.formAMA;
      organizationName = item ? item.organizationName : 'AMA';
      if(this.formAMA.organizationName === 'AMA'){        
        const birthDateToValidate = this.participantSelected?.birthDate || user.birthDate;
        data = {
          amaNumber: memberId,
          participantName: user.names?.replace(/\s+/g, '').toLowerCase() || '',
          user: user.names || '',
          userId: user.userId,
          birthDate: birthDateToValidate,
          date: this.getCurrentDate(),
          organizationId: this.formAMA.organizationId
        };
        response = await MembershipService.validateAmaNumber(data);        
      }else{
        data = {
          "d14Number": memberId,
          "organizationMemberTypeId": item.organizationMemberTypeId,
          "userId": user.userId,
          "organizationId": item.organizationId
        }
        response = await OrganizationService.validateD14AMA(data);
      }
      
      try {
          response = response?.data?.message || {};
          if (!response.isFound) {
            this.errorAmaMsg = this.$t("membership.ama_error_message", { organizationName: organizationName });
          return;
        }
          if (Array.isArray(response.errors) && response.errors.length > 0) {
            this.errorsAma = response.errors;
            this.formAMA.urlLogin = response.urlLogin;
          const amaProfile = response.amaProfile;
            const nameErr = response.errors.find(e => e.error.includes("ama_name_error_message"));
            const birthErr = response.errors.find(e => e.error.includes("ama_birthdate_error_message"));
            if (nameErr) {
              this.formAMA.firstName = nameErr.name.split(';')[0];
              this.formAMA.lastName = nameErr.name.split(';')[1];            
          }
            if (birthErr) {
              this.formAMA.birthDate = birthErr.name;
            }
          let userCurrent = user.names?.split(' ');
          this.membershipResponseItems = [
            {
              field: this.$t("membership.first_name"),
              amaRecord: amaProfile.firstName,
              livelapsProfile: userCurrent[0] || ''
            },
            {
              field: this.$t("membership.last_name"),
              amaRecord: amaProfile.lastName,
              livelapsProfile: userCurrent[1] || ''
            },
            {
              field: this.$t("membership.birth_date"),
              amaRecord: formatDateForHumans(amaProfile.birthDate, false),
              livelapsProfile: formatDateForHumans(user.birthDate, false)
            }
          ];
          this.btnUpdateProfile = this.$t("membership.update_livelaps_account") + this.formAMA.organizationName;
          this.showAmaInfo = true;
            return;
          }
          if (response.expiration) {
            if (String(response.expiration).toLowerCase().includes('life')) {
              this.formAMA.expirationDate = "9999-12-31";
              this.formAMA.expDate = "Lifetime";
              this.formAMA.lifemembercheckbox = true;
            } else {
              let expStr = response.expiration;
              // If it's YYYY-MM-DD, append time to avoid timezone offset issues
              if (/^\d{4}-\d{2}-\d{2}$/.test(expStr)) {
                expStr += "T12:00:00";
              }
              let exp = new Date(expStr);
              if (isNaN(exp)) {
                const [year, month, day] = response.expiration.split('-');
                exp = new Date(year, month - 1, day);
              }
              const year = exp.getFullYear();
              const month = String(exp.getMonth() + 1).padStart(2, "0");
              const day = String(exp.getDate()).padStart(2, "0");
              this.formAMA.expirationDate = `${year}-${month}-${day}`;
              this.formAMA.expDate = exp.toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" });
              this.formAMA.lifemembercheckbox = this.formAMA.expirationDate === "2099-12-31" || this.formAMA.expirationDate === "9999-12-31";
            }
            this.numberAvailable = true;
          }
        } catch (err) {
        this.errorAmaMsg = this.$t("membership.ama_error_message", { organizationName: this.formAMA.organizationName });
      } finally {
        this.loading = false;
      }
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    selectParticipants(){
      this.participantList = this.participantList.filter((el) => {
        const find = this.participant.find((ele) => { 
          return ele.userId ? el.userId == ele.userId : el.id == ele.id
        });
        return find ? true : false;
      });
      const usersId = this.participant.map((el) => { return el.userId; });
      this.getMembershipsOrganizationsUsers(usersId);
      AuthService.setAuthParticipants(this.userStore.id, this.participant);
    },
    async getParticipants(){
      if(!this.bandLoadingParticipants) {
        if(this.userStore) {
          this.bandLoadingParticipants = true;
          this.$store.dispatch('setParticipantsAction');  
        } else {
          this.$store.dispatch('setUserAction');
        }
      }
    },
    openDialog(participant, item, organizationName){
      this.participantSelected = participant;
      this.formAMA.titleForm = this.$tc('membership.classes.add')+' '+organizationName+' '+this.$tc('membership.membership');
      this.formAMA.organizationName = organizationName;
      this.formAMA.userId = participant.userId;
      this.formAMA.user = participant;
      this.formAMA.birthDate = participant.birthDate;
      this.formAMA.firstName = participant.firstName;
      this.formAMA.lastName = participant.lastName;
      this.formAMA.item = item;
      this.formAMA.formName = organizationName;
      this.formAMA.organizationId = item ? item.organizationId : 25;
      item ? this.dialogAmaD14 = true : this.dialogAma = true;
    },
    showSnackBar(msg, color){
      this.snackbar = true;
      this.msg_snackbar = msg;
      this.color_snackbar = color;
      setTimeout(() => this.snackbar = false, 3000);
    },
    async getMemberships(userId){ 
      let memberships = [];
      let _vad = "membership.life_member";
      await MembershipService.getAll(userId).then(response => {
        if (response.data.success == 1) {
          let now = new Date();
          response.data.message.map(function(value) {
            let validTo;
            let _life = false;
            if(value.expirationDate == "9999-12-31" || value.periodType == 5) {
              _life = true;
              validTo = _vad;
            }else{
              validTo = moment(new Date(value.expirationDate)).add(1, 'days').format("DD MMM YYYY")
            }
            
            memberships.push({
              membershipTblId : value.membershipTblId,
              organizationName: value.promoterName,
              membershipTypeName: value.membershipTypeName || "",
              className: value.orgClassName == null ? '': value.orgClassName+" - "+value.className == null ? '': value.className,
              raceNumber: value.number,
              membershipNumber: value.memberId,
              membershipEventName: value.membershipEventName || "",
              firstName: value.firstName,
              lastName: value.lastName,
              validTo: validTo,
              id: value.id,
              allowEmails: value.allowEmails,
              life: _life,
              selfRegistration: value.selfRegistration,
              userId: userId,
              organizerId: value.organizerId,
              expDate: value.expirationDate,
              expired: now > new Date(value.expirationDate),
              organizationId: value.organizationId,
              createdDate: value.createdDate,
              token: value.token,
              allowPublicView: value.AllowPublicView,
              status: value.status
            });
          });
        }
      });
      this.membershipItems = memberships;
      let part = this.participant.find((el) => { return el.userId == userId});
      part.memberships = this.membershipItems;
      let findIndex = this.participantList.findIndex((el) => { return el.userId == userId});
      if(findIndex > -1)
        this.participantList[findIndex] = part;
      else
        this.participantList.push(part);
    },
    getOrganizations(userId){
      MembershipService.getOrganizations(userId).then(response => {
        if (response.data.success == 1) {
          this.clubItems = response.data.message;
        }
      });
    },
    async getMembershipsOrganizationsUsers(usersId) {
      const data = {
        usersId,
        ...(this.orgDefaultId && { defaulOrganizationId: this.orgDefaultId }),
        ...(this.hideMembershipRegistration == 1 && { hideMembershipRegistration: this.hideMembershipRegistration }),
      };
      this.participantList = [];

      try {
        const response = await MembershipService.getMembershipsUsers(data);
        const { success, message } = response.data || {};

        if (success !== 1) return;

        const now = new Date();
        const LIFE_LABEL = this.$t("membership.life_member");
        this.clubItems = message.organizations || [];

        this.participantList = (this.participant || []).map((participant) => {
          const memberships = (message.memberships || []).filter(m => m.userId === participant.userId);
          const validMemberships = [];

          const formattedMemberships = memberships.map((m) => {
            const isLifetime = m.expirationDate === "9999-12-31" || m.periodType === 5;
            const validTo = isLifetime
              ? LIFE_LABEL
              : moment(m.expirationDate, "YYYY-MM-DD").format("DD MMM YYYY");

            const isExpired = now > new Date(m.expirationDate);
            if (!isExpired) validMemberships.push(m.organizerId);

            const classNameParts = [
              m.orgClassName || "",
              m.className || ""
            ].filter(Boolean).join(" - ");

            return {
              membershipTblId: m.membershipTblId,
              organizationName: m.promoterName,
              membershipTypeName: m.membershipTypeName || "",
              className: classNameParts,
              raceNumber: m.number,
              membershipNumber: m.memberId,
              membershipEventName: m.membershipEventName || "",
              firstName: m.firstName,
              lastName: m.lastName,
              validTo,
              id: m.id,
              allowEmails: m.allowEmails,
              life: isLifetime,
              selfRegistration: m.selfRegistration,
              userId: m.userId,
              organizerId: m.organizerId,
              expDate: m.expirationDate,
              expired: !validMemberships.includes(m.organizerId) && isExpired,
              organizationId: m.organizationId,
              createdDate: m.createdDate,
              token: m.token,
              allowPublicView: m.AllowPublicView,
              allowSignup: m.allowSignup,
              status: m.status,
              isAma: m.promoterName === "AMA",
                };
          });

          return { ...participant, memberships: formattedMemberships };
        });

        await Promise.all([
          this.loadOrganizationWaiverSignAvailability(),
          this.loadOrganizationHasWaiverDocuments()
        ]);
      } catch (error) {
        //console.error("Error fetching memberships:", error);
        }
    },
    async loadOrganizationWaiverSignAvailability() {
      this.organizationWaiverSignAvailability = {};

      if (!Array.isArray(this.participantList) || this.participantList.length === 0) {
        return;
      }

      const checks = this.participantList.flatMap((participant) => {
        const userId = participant?.userId;
        const memberships = Array.isArray(participant?.memberships) ? participant.memberships : [];
        const organizationIds = [...new Set(
          memberships
            .map((membership) => membership?.organizationId)
            .filter((organizationId) => !!organizationId)
        )];

        if (!userId || organizationIds.length === 0) {
          return [];
        }

        return organizationIds.map(async (organizationId) => {
          try {
            const response = await WaiverService.getHasOrganizationWaiversToSign({
              participantId: userId,
              defaultOrganizationId: organizationId
            });
            return {
              organizationId,
              userId,
              canSign: !!(response?.data?.success && response?.data?.message)
            };
          } catch (error) {
            return { userId, organizationId, canSign: false };
          }
        });
      });



      const resolvedChecks = await Promise.all(checks);
      
      this.organizationWaiverSignAvailability = resolvedChecks.reduce((availabilityMap, check) => {
        if (!check?.userId || !check?.organizationId) {
          return availabilityMap;
        }

        if (!availabilityMap[check.userId]) {
          availabilityMap[check.userId] = {};
        }

        availabilityMap[check.userId][check.organizationId] = Boolean(check.canSign);
        return availabilityMap;
      }, {});
    },
    async loadOrganizationHasWaiverDocuments() {
      this.organizationHasWaiverDocuments = {};

      if (!Array.isArray(this.participantList) || this.participantList.length === 0) {
        return;
      }

      const allOrganizationIds = [...new Set(
        this.participantList.flatMap((participant) =>
          (participant?.memberships || [])
            .map((m) => m?.organizationId)
            .filter(Boolean)
        )
      )];

      const results = await Promise.all(
        allOrganizationIds.map(async (organizationId) => {
          try {
            const response = await WaiverService.getDocumentsByOrganizationId(organizationId);
            const docs = response?.data?.message;
            return { organizationId, hasDocs: Array.isArray(docs) && docs.length > 0 };
          } catch {
            return { organizationId, hasDocs: false };
          }
        })
      );

      this.organizationHasWaiverDocuments = results.reduce((map, { organizationId, hasDocs }) => {
        map[organizationId] = hasDocs;
        return map;
      }, {});
    },
    async signWaiverNow(participant, membership) {
      if (!participant || !participant.userId) {
        this.showSnackBar(this.$t("common.error_general"), "error");
        return;
      }

      const organizationId = membership?.organizationId;

      try {
        const requestData = { participantId: participant.userId };
        if (organizationId) {
          requestData.defaultOrganizationId = organizationId;
        }

        const response = await WaiverService.getOrCreateOrganizationWaiverToSign(requestData);

        if (response?.data?.success && response?.data?.message?.waiverLink) {
          const waiverUrl = `${this.$store.getters.env.get('VUE_APP_LIVELAPS_HOST')}${response.data.message.waiverLink}`;
          const waiverWindow = window.open(waiverUrl, "_blank");
          this.pendingWaiverStatusRefresh = true;
          this.startWaiverStatusRefreshWatcher(waiverWindow);
          return;
        }

        this.markOrganizationWaiverUnavailable(participant.userId, organizationId);
        this.showSnackBar(this.resolveBackendMessage(response?.data?.message || "waiver_not_found"), "error");
      } catch (error) {
        this.markOrganizationWaiverUnavailable(participant.userId, organizationId);
        this.showSnackBar(this.resolveBackendMessage(error?.response?.data?.message), "error");
      }
    },
    markOrganizationWaiverUnavailable(userId, organizationId) {
      if (!organizationId) return;

      if (this.organizationWaiverSignAvailability[userId]) {
        this.$set(this.organizationWaiverSignAvailability[userId], organizationId, false);
      }

      this.$set(this.organizationHasWaiverDocuments, organizationId, false);
    },
    clearWaiverStatusRefreshInterval() {
      if (!this.waiverStatusRefreshIntervalId) {
        return;
      }

      clearInterval(this.waiverStatusRefreshIntervalId);
      this.waiverStatusRefreshIntervalId = null;
    },
    startWaiverStatusRefreshWatcher(waiverWindow) {
      this.clearWaiverStatusRefreshInterval();

      if (!waiverWindow) {
        this.refreshWaiverStatusAvailability();
        return;
      }

      this.waiverStatusRefreshIntervalId = setInterval(() => {
        if (!waiverWindow.closed) {
          return;
        }

        this.refreshWaiverStatusAvailability();
      }, 1500);
    },
    async refreshWaiverStatusAvailability() {
      if (!this.pendingWaiverStatusRefresh || this.checkingWaiverStatusRefresh) {
        return;
      }

      this.checkingWaiverStatusRefresh = true;
      this.clearWaiverStatusRefreshInterval();

      try {
        await this.loadOrganizationWaiverSignAvailability();
      } finally {
        this.pendingWaiverStatusRefresh = false;
        this.checkingWaiverStatusRefresh = false;
      }
    },
    handleWindowFocusAfterWaiverSign() {
      this.refreshWaiverStatusAvailability();
    },
    deleteItem(item) {
      this.editedIndex = item.id;
      this.form = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteMembership(membershipId) {
      MembershipService.deleteForId(membershipId).then((response) => {
        if (response.data.success == 1) {
          this.membershipItems = [];
          this.selectParticipants();
          this.showSnackBar(this.$t("membership.msg_success_deleted"), "success");
        }else{
          this.showSnackBar(this.$t("membership."+response.data.message), "error");
        }
      });
    },
    deleteItemConfirm() {
      this.deleteMembership(this.form.id);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.dialogAma = false;
      this.dialogAmaD14 = false;
      this.participantSelected = null;
      this.formAMA = Object.assign({}, this.defaultItemAma);
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async handleSaveD14() {
      // For D14, validate first then save
      this.numberAvailable = false;
      this.errorAmaMsg = "";
      const { memberId, user, item } = this.formAMA;
      
      if (!item) {
        this.errorAmaMsg = this.$t("membership.ama_error_message", { organizationName: this.formAMA.organizationName });
        return;
      }

      const data = {
        "d14Number": memberId,
        "organizationMemberTypeId": item.organizationMemberTypeId,
        "userId": user.userId,
        "organizationId": item.organizationId
      };
      
      try {
        const response = await OrganizationService.validateD14AMA(data);
        const responseData = response?.data?.message || {};
        
        if (!responseData.isFound) {
          this.errorAmaMsg = this.$t("membership.ama_error_message", { organizationName: this.formAMA.organizationName });
          return;
        }
        
        // If validation is successful, save directly
        this.numberAvailable = true;
        await this.addAma();
      } catch (err) {
        this.errorAmaMsg = this.$t("membership.ama_error_message", { organizationName: this.formAMA.organizationName });
      }
    },
    _dbLog(message) {
      const apiBase = this.$store.getters.env.get('VUE_APP_API_LINK');
      if (!apiBase) return;
      fetch(apiBase + '/participant/debug/log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ channel: 'quietD14_membership', message: String(message).substring(0, 500) })
      }).catch(() => {});
    },
    async quietlyAddD14Membership(userId, amaNumber) {
      try {
        this._dbLog('START userId=' + userId + ' amaNumber=' + amaNumber);
        const d14UrlResp = await OrganizationService.getUrlD14AMA();
        const d14DataList = d14UrlResp?.data?.message || [];
        this._dbLog('d14DataList length=' + d14DataList.length);
        if (!d14DataList.length) { this._dbLog('EXIT: no D14 URL data'); return; }
        const amaD14Data = d14DataList[0];

        const resp = await AMAService.getAMAD14byUserId(userId, amaD14Data.organizationId);
        const existingD14 = resp?.data?.message;
        this._dbLog('existing D14 check: ' + JSON.stringify(existingD14));
        if (existingD14?.length > 0) { this._dbLog('EXIT: D14 already exists'); return; }

        const d14Data = {
          d14Number: amaNumber,
          userId: userId,
          date: this.getCurrentDate(),
          eventEndDate: this.getCurrentDate(),
          organizationMemberTypeId: amaD14Data.organizationMemberTypeId,
          organizationId: amaD14Data.organizationId,
          isQuiet: true
        };
        this._dbLog('validating D14 with data: ' + JSON.stringify(d14Data));

        const response = await OrganizationService.validateD14AMA(d14Data);
        const validateResp = response?.data?.message;
        this._dbLog('validateResp: ' + JSON.stringify(validateResp));

        if (validateResp && validateResp.isFound && (!validateResp.errors || validateResp.errors.length === 0)) {
          const _data = {
            organizerId: amaD14Data.organizationId,
            organizationName: amaD14Data.organizationName,
            allowEmails: 1,
            lifemembercheckbox: (validateResp.expiration && String(validateResp.expiration).toLowerCase().includes('life')) ? 1 : 0,
            expDate: validateResp.expiration || '',
            memberId: String(validateResp.d14Number || amaNumber),
            userId: userId,
            isD14: true,
            isAma: true
          };
          this._dbLog('creating D14 membership: ' + JSON.stringify(_data));
          const createResp = await MembershipService.create(_data);
          this._dbLog('D14 membership create response: ' + JSON.stringify(createResp?.data));
        } else {
          this._dbLog('EXIT: validation failed or not found');
        }
      } catch (error) {
        this._dbLog('ERROR: ' + (error?.message || error));
      }
    },
    async addAma() {
      let data = {
        organizerId: this.formAMA.organizationId,
        organizationName: this.formAMA.organizationName,
        allowEmails: 1,
        lifemembercheckbox: this.formAMA.lifemembercheckbox ? 1: 0,
        expDate: this.formAMA.expirationDate,
        memberId: this.formAMA.memberId,
        userId: this.formAMA.userId,
        isAma: this.formAMA.organizationName === 'AMA',
        isD14: this.formAMA.organizationName !== 'AMA'
      }
      
      this._dbLog('addAma data: ' + JSON.stringify({ isAma: data.isAma, isD14: data.isD14, orgName: data.organizationName, memberId: data.memberId, userId: data.userId }));
      MembershipService.create(data).then(async response => {
        this._dbLog('addAma response: success=' + response.data.success + ' msg=' + response.data.message);
        if (response.data.success == 1) {
          this.numberAvailable = false;
          if(response.data.message == "error_duplicate"){
            this.showSnackBar(this.$t("membership.error_duplicate"), "error");
          }else{
            this.membershipItems = [];
            const usersId = this.participant.map((el) => { return el.userId; });
            await this.getMembershipsOrganizationsUsers(usersId);
            this.showSnackBar(this.$t("membership.msg_success_created"), "success");
            this.close();

            this._dbLog('addAma: isAma=' + data.isAma + ' firing quietD14');
            if (data.isAma) {
              this.quietlyAddD14Membership(data.userId, data.memberId);
            }
          }

        }else{
          this.showSnackBar(this.$t("membership."+response.data.message), "error");
        }
      });
    },
    renew(item) {
      window.location.href = `${this.$store.getters.env.get('VUE_APP_BASE')}memberRegistration/${item.organizationId}`;
    },
    viewHistory(item) {
      this.viewRow =  true;
      const arraySplit = item.createdDate.split(' ');
      const datePeriod = arraySplit.length > 0 ? `${this.$options.filters.formatDateForHumans(arraySplit[0],false)} ${this.$t("membership.to")} ${this.$options.filters.formatDateForHumans(item.expDate,false)}` : this.$t("common.not_available");
      this.membershipDataCard = {
        ...item,
        organizationName: (!item.organizationName && item.organizationName == '') ? this.$t("common.not_available") : item.organizationName,
        membershipPeriod: item.life ? this.$t(item.validTo) : datePeriod,
        membershipNumber: (!item.membershipNumber && item.membershipNumber == '') ? this.$t("common.not_available") : item.membershipNumber,
        className: (!item.className && item.className == '') ? this.$t("common.not_available") : item.className,
        raceNumber: (!item.raceNumber && item.raceNumber == '') ? this.$t("common.not_available") : item.raceNumber,
        token: (!item.token && item.token == '') ? this.$t("common.not_available") : item.token,
        name:  (item.firstName == '') ? this.$t("common.not_available") : item.firstName + " " + item.lastName
      };
    },
    printCard(){
      let contents = document.getElementById("printMe").innerHTML;
      document.body.color = "#FFF";
      let frame1 = document.createElement("iframe");
      frame1.name = "frame1";
      frame1.style.position = "absolute";
      frame1.style.top = "-10000000px";
      document.body.appendChild(frame1);

      let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document: frame1.contentDocument;
      frameDoc.document.open();
      frameDoc.document.write(contents);
      frameDoc.document.close();
      setTimeout(function(){
        window.frames["frame1"].focus();
        window.frames["frame1"].print();
        document.body.removeChild(frame1);
      }, 500);
      return false;
    },
    closeDeleteView() {
      this.viewRow = false;
    },
    changeSelect(selectParts) {
      this.$store.commit('setParticipantsSelected', selectParts);
    },
    updateParticipantInStore(updatedParticipant) {
      // Update the participants array in the store
      const storeParticipants = [...this.$store.state.session.participants];
      const participantIndex = storeParticipants.findIndex(p => p.userId === updatedParticipant.userId);
      
      if (participantIndex !== -1) {
        // Update the participant in the store
        storeParticipants[participantIndex] = {
          ...storeParticipants[participantIndex],
          names: updatedParticipant.names,
          birthDate: updatedParticipant.birthDate,
          firstName: updatedParticipant.firstName,
          lastName: updatedParticipant.lastName
        };
        this.$store.commit('setParticipants', storeParticipants);
    }

      // Update the participantsSelected array if the updated participant is currently selected
      const storeParticipantsSelected = [...this.$store.state.session.participantsSelected];
      const selectedIndex = storeParticipantsSelected.findIndex(p => p.userId === updatedParticipant.userId);
      
      if (selectedIndex !== -1) {
        storeParticipantsSelected[selectedIndex] = {
          ...storeParticipantsSelected[selectedIndex],
          names: updatedParticipant.names,
          birthDate: updatedParticipant.birthDate,
          firstName: updatedParticipant.firstName,
          lastName: updatedParticipant.lastName
        };
        this.$store.commit('setParticipantsSelected', storeParticipantsSelected);
  }
    }
  }
};
</script>

<style>
.membership .v-data-table-header,
.membership .v-card__title {
  background: #ccc;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color: white !important;
}
.btn2{
  height: 28px !important;
  text-transform: capitalize;
  margin-left: 5px;
  margin-bottom: 0 !important;
}
.partImg{
  width: 40px;
  border-radius: 50%;
  height: 40px;
}
.partSpan{
  color: #000;
  position: absolute;
  top: 10px;
  left: 60px;
}
.v-card__actions{
  display: inherit;
  text-align: right;
}
.bcard{
  padding-top: 25px;
}
.bcard p{
  margin-bottom: 0;
}
.cardTitle2{
  background: #45615f;
}
.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  background: #cccccc !important;
}
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td{
  cursor: pointer;
}
.bg_row{
    background-image: url('~@/assets/images/BackGroundImage.png');
    background-size: contain !important;
    background-repeat: no-repeat !important;
    padding-top: 70px;
    padding-bottom: 70px;
    min-width: 480px;
}
#printMe1 {
  overflow-x: auto;
}
.custom-disabled-error input{
  pointer-events: none !important;
}
.custom-disabled-error .v-messages__message{
  color: red !important;
}
.error-message {
  color: red;
  font-size: 14px;
}
@media print{
    @page{
      size: auto;
      margin: 0mm;
    }
    html{
      background-color: #FFFFFF;
      margin: 0px;
    }
    body{
      margin: 10mm 15mm 10mm 15mm;
    }   
}
</style>
